import { render, staticRenderFns } from "./importProductBrand.vue?vue&type=template&id=fce8dea6&"
import script from "./importProductBrand.vue?vue&type=script&lang=js&"
export * from "./importProductBrand.vue?vue&type=script&lang=js&"
import style0 from "./importProductBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports